import 'webfontloader';

window.WebFontConfig = {
  google: {
    families: ['Noto+Sans+JP:400,700']
  }
};
(function() {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();

$(function() {
  $('.p-faq-list__header').on('click', function() {
    $(this).toggleClass('is-active');
    $(this).next().slideToggle(200);
  });
});
